import { BrandMock } from '@principle-theorem/principle-core';
import { IBrandDimension } from '@principle-theorem/reporting/interfaces';
import {
  MockGenerator,
  toSerialisedTimestamp,
  toTimestamp,
} from '@principle-theorem/shared';
import { BigQueryFirestoreModelMock } from './common.mock';

const brand = MockGenerator.generate(BrandMock);

export class BrandDimensionMock
  extends BigQueryFirestoreModelMock<IBrandDimension>
  implements IBrandDimension
{
  timestamp = toSerialisedTimestamp(toTimestamp());
  name = brand.name;
  slug = brand.slug;
  settings = brand.settings;
}
